import { createContext, useContext } from "react";

export enum MessageType {
    Err = "error",
    Success = "success",
    Warn = "warning",
}

export interface Snack {
    type: MessageType;
    message: string;
    open: boolean;
}

interface SnackbarContextType {
    snack: Snack;
    setSnack: (snack: Snack) => void;
}

export const DEFAULT_SNACK: Snack = {
    type: MessageType.Success,
    message: "",
    open: false,
};

export const SnackbarContext = createContext<SnackbarContextType>({
    snack: DEFAULT_SNACK,
    setSnack: () => {},
});

export function useHandleNotistack() {
    const { setSnack } = useContext(SnackbarContext);
    return function notistackHandler(type: MessageType, message: string) {
        setSnack({ type: type, message: message, open: true });
    };
}
